/*
----- Message Event interface -----

Used for communication between parent pages and Iframes, can also be used to communicate between tabs as well.

If using a sandbox iframe this is prefer way to communicate with PCI complience in mind, here is a good article explaining this: https://www.shopify.com/in/partners/blog/checkout-compliance

*/



const whitelist = [
    "https://www.google.com",
    "https://tagassistant.google.com",
    "https://datahose-colour-journey.akzonobel.hosting",
    "https://sandbox.opayo.eu.elavon.com",
    "https://live.opayo.eu.elavon.com",
    "https://test.sagepay.com",
    "https://sagepay.com",
    "https://applepay.cdn-apple.com",
    "https://widget.trustpilot.com",
    "https://consentcdn.cookiebot.eu",
    "https://consentcdn.cookiebot.com"
];

// Get Iframe Id.
function getFrameId(data) {
    // Get frame id.
    const id = (data.hasOwnProperty('frame-id') ? data['frame-id'] : null);
    return id;    
}

// Get Iframe context element.
function getFrameContext(id) {
    // Get element from DOM.
    const element = $('iframe#' + id);
    return element;
}

function initialise() {
    window.onmessage = function(event) {
        // Store origin for security check.
        const origin = event.origin;
        // Do we need to block communication?
        if (origin != location.origin && !whitelist.includes(origin)) {
            console.error("Message blocked", origin);
            return false;
        }
        // Same origin.
        const sameOrigin = (origin == location.origin);
        // Get message.
        const message = event['data'];
        // Get message data.
        const data = (message.hasOwnProperty('data') ? message['data'] : null); 
        if (AXISDebug.level() >= 2) {
            AXISDebug.output(1,"Message Interface: Message recieved: ", event);
        }
        // Opayo gives us a type which we can use to derive an option, this is not standard and different api's will have different structures.
        let operation = (message.hasOwnProperty('operation') ? message['operation'] : null);
        // Opayo's "operation".
        if (!operation) {
            operation = (message.hasOwnProperty('type') ? message['type'] : null);
        }
        if (operation) {
            handleOperation(operation, data, sameOrigin);
        } else {
            // Fallback to the original implementation, this can essentially be phased out once Opayo Pi becomes common use.
            // Provides an id of a form that we're going to submit.
            let submit = (message.hasOwnProperty('submit-form') ? message['submit-form'] : false);
            if (submit) {
                // Find form.
                let form = $('#' + submit);
                if (!form.length) {
                    console.error("Message Event: Could not find form to submit.");
                    return false;
                }
                if (AXISDebug.level() >= 2) {
                    AXISDebug.output(1,"Message Event: Attempting to submit this form", form);
                }
                // Submit form.
                form.submit();
            }
            let closeModal = (message.hasOwnProperty('close-modal') ? message['close-modal'] : false);
            if (closeModal) {
                if (AXISDebug.level() >= 2) {
                    AXISDebug.output(1,"Message Event: Attempting to close modals");
                }
                // Close popup.
                AXISModals.modalClose();
            }
        }
    }
}

// Handle Operation.
function handleOperation(operation, data, sameOrigin) {
    switch(operation) {
        case "frame-resize":
            iframeResize(data);
            break;
        case "processing-payment":
            processPaymentSpinner(data);
            break;
        case "on-page-notification":
            displayOnPageNotification(data, sameOrigin);
            break;
        case "update-location":
            updateWindowLocation(data, sameOrigin);
            break;
        case "hosted-page-loaded":
            opayoPageLoaded();
            break;
        default:
            if (AXISDebug.level() >= 3) {
                console.log("Message Interface: Operation not supported ", operation);
            }
    }
}

// Resize iframe.
function iframeResize(data) {
    // Get frame id.
    const frameId = getFrameId(data);
    // Get frame dimensions.
    const frameDimensions = (data.hasOwnProperty('css-properties') ? data['css-properties'] : null);
    if (!frameId || !frameDimensions) {
        AXISDebug.output(3,"Frame Resize: Failed to resize due to invalid data provided");
        return false;
    }
    frameResize(data['frame-id'], data['css-properties']);
}

// Process payment spinner.
function processPaymentSpinner(data) {
    // Get frame id.
    const frameId = getFrameId(data);
    if (!frameId) {
        AXISDebug.output(3,"Processing Payment: Unable to output spinner due to no iframe id provided");
        return false;
    }
    // Find frame.
    const frame = getFrameContext(frameId);
    if (!frame.length) {
        AXISDebug.output(3,"Processing Payment: Could not find frame");
        return false;
    }
    // Get uiblock markup.
    const uiblocker = AXISAjax.getContentBlockSpinner();
    $(uiblocker).insertBefore(frame);
}

// Display on page notification, provide an a container id for the notification will be added within or if an iframe the frame will be replace with the notification.
function displayOnPageNotification(data, sameOrigin) {
    if (sameOrigin) {
        // Get container id.
        const containerId = (data.hasOwnProperty('container-id') ? data['container-id'] : null);
        if (!frameId && !containerId) {
            AXISDebug.output(3,"On Page Notification: Unable to output notification due to no iframe id or container id provided");
            return false;
        }
        // The container of which the notification gets injected into.
        const container = $('#' + containerId);
        if (!container.length) {
            AXISDebug.output(3,"On Page Notification: Could not find container to inject into within DOM.", containerId);
            return false;
        }
        // Detect if container is an iframe.
        const isFrame = container.is('iframe');
        // Get type.
        const type = (data.hasOwnProperty('type') ? data['type'] : "success");
        // Get Text.
        const text = (data.hasOwnProperty('text') ? data['text'] : null);
        if (!text) {
            AXISDebug.output(2,"On Page Notification: No text provided for notification");
        }
        // Build notification.
        const notification = displayOnPageNotificationTemplate(type, text);
        // If is an iframe then replace it, otherwise add the notification within the container.
        if (isFrame) {
            container.replaceWith(notification);
        } else {
            container.html(notification);
        }
    }
}

function displayOnPageNotificationTemplate(type, text) {
    const html = `
        <div class="on-page-notification ${type}">
            <div class="content-container"><p>${text}</p></div>
        </div>`;
    return html;
}

// Update location ( i.e. client redirect ).
function updateWindowLocation(data, sameOrigin) {
    // You can only update the location if same origin.
    if (sameOrigin) {
        // Get location.
        const url = (data.hasOwnProperty('url') ? data['url'] : null);
        if (!url) {
            AXISDebug.output(3,"Update Location: No url provided");
            return false;
        }
        window.location.href = url;
    }
}

// Opayo host page loaded.
function opayoPageLoaded() {
    /*
            
    Due to doing a full page form post a UI blocker gets outputted ( as this request can take a couple of seconds ) but the Opayo checkout JS library does not signal to us if their form validation has failed when submitting the form. We do no have any context of whats going on inside of the iframe at this point, the only thing that gets triggered is this message ( no invalid event, no signalling in the DOM via attributes and event.preventDefault() doesn't get called ).

    Due to no context given in the message event.data, we're assuming there will only be one active instance / payment form at one given time.

    */
    const form = axisPaymentMethods.getActiveForm("opayo");
    // Check if there is a UI blocker active.
    const uiBlocker = form.find('[' + expressSelectors()['ajax']['content-block-element'] + ']');
    if (uiBlocker.length) {
        uiBlocker.remove();
    }
}



var messageEvents = $.messageEvents = {
    initialise: () => {
       return initialise();
    }
}

export { messageEvents }
